import { FC, useState } from 'react';
import DownloadIcon from '@mui/icons-material/Download';
import { Button, CircularProgress } from '@mui/material';
import { UploadedFile } from '../../../core/types/transport/api/uploadFilesResponse';
import { apiPath, getAccessToken } from '../../api';
import { config } from '../../config/transport';

export const FileLink: FC<{ file: UploadedFile }> = ({ file }) => {
  const [isDownloading, setIsDownloading] = useState<boolean>(false);

  const download = async (f: UploadedFile) => {
    setIsDownloading(true);
    try {
      const token = await getAccessToken(config);
      const response = await fetch(
        `${apiPath(config, `transport/files/${f.id}`)}`,
        {
          method: 'GET',
          mode: 'cors',
          credentials: 'include',
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const blob = await response.blob();

      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.target = '_blank';

      response.headers.get('content-disposition');
      const filename = response.headers
        .get('content-disposition')
        ?.split('filename=')[1];
      a.download = filename || file.fileName;
      a.click();
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <Button
      variant="text"
      endIcon={isDownloading ? <CircularProgress size={20} /> : <DownloadIcon />}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        download(file);
      }}
      sx={{ textTransform: 'none', padding: 0, minWidth: 0 }}
    >
      {file.fileName}
    </Button>
  );
};
